import React, { LegacyRef } from "react";

import About from "./components/about-me/AboutMe";
import Contact from "./components/contact/Contact";
import Experience from "./components/experience/Experience";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Nav from "./components/nav/Nav";
import Skills from "./components/skills/Skills";

export type SectionProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  observeElement: LegacyRef<any> | undefined;
};

export enum Sections {
  HEADER = "header",
  ABOUT_ME = "about-me",
  SKILLS = "skills",
  EXPERIENCE = "experience",
  CONTACT = "contact",
}

const App = () => {
  // Callback function to be triggered when an element enters the window.
  const callback: IntersectionObserverCallback = (entries) => {
    // Loop through all elements that are now in window.
    entries.forEach((entry) => {
      entry.target.classList.toggle("hide", !entry.isIntersecting);
      entry.target.classList.toggle("show", entry.isIntersecting);
    });
  };

  // Observer that checks if element is in window.
  const observer = new IntersectionObserver(callback);

  // Add element to observer when element is mounted
  const refCallback = (element: HTMLDivElement | null) =>
    element !== null && observer.observe(element);

  return (
    <>
      <Header observeElement={refCallback} />
      <Nav />
      <About observeElement={refCallback} />
      <Skills observeElement={refCallback} />
      <Experience observeElement={refCallback} />
      <Contact observeElement={refCallback} />
      <Footer />
    </>
  );
};

export default App;
